import { render, staticRenderFns } from "./kitchenL.vue?vue&type=template&id=3c672ad0&scoped=true&"
import script from "./kitchenL.vue?vue&type=script&lang=js&"
export * from "./kitchenL.vue?vue&type=script&lang=js&"
import style0 from "./kitchenL.vue?vue&type=style&index=0&id=3c672ad0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c672ad0",
  null
  
)

export default component.exports